<template>
  <div class="log" ref="logContainer">
    <div 
      v-for="logEntry in logs" 
      :key="logEntry.id"
      class="log-entry"
      :class="logEntry.type"
    >
      [{{ formatTime(logEntry.timestamp) }}] {{ logEntry.message }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch, nextTick } from 'vue';
import { useGameStore } from '@/stores/gameStore';

const store = useGameStore();
const logContainer = ref<HTMLElement>();

const logs = computed(() => store.logs);

const formatTime = (timestamp: number) => {
  return new Date(timestamp).toLocaleTimeString();
};

// Auto-scroll to bottom when new logs are added
watch(logs, () => {
  nextTick(() => {
    if (logContainer.value) {
      logContainer.value.scrollTop = logContainer.value.scrollHeight;
    }
  });
}, { deep: true });
</script>

<style scoped>
.log {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid #444;
  border-radius: 8px;
  padding: 15px;
  height: 200px;
  overflow-y: auto;
  font-family: 'Courier New', monospace;
  font-size: 0.9em;
  line-height: 1.4;
}

.log-entry {
  margin-bottom: 5px;
  padding: 2px 0;
}

.log-entry.success {
  color: #00ff88;
}

.log-entry.warning {
  color: #ffaa00;
}

.log-entry.error {
  color: #ff4444;
}

.log-entry.info {
  color: #00aaff;
}

/* Scrollbar styling */
.log::-webkit-scrollbar {
  width: 8px;
}

.log::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.log::-webkit-scrollbar-thumb {
  background: rgba(0, 255, 136, 0.3);
  border-radius: 4px;
}

.log::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 255, 136, 0.5);
}
</style> 